import { Directive } from '@angular/core';
import { BrnDialogContent } from '@spartan-ng/brain/dialog';

/**
 * Structural directive that acts as the portal for the dialog content.
 * Applied as `*hlmDialogPortal` on the `<hlm-dialog-content>` element.
 *
 * Extends `BrnDialogContent` which registers the template with the parent
 * BrnDialog and opens it in a CDK overlay when the dialog is opened.
 *
 * @example
 * <hlm-dialog-content *hlmDialogPortal>...</hlm-dialog-content>
 */
@Directive({
  selector: '[hlmDialogPortal]',
  standalone: true,
  hostDirectives: [BrnDialogContent],
})
export class HlmDialogPortalDirective {}
